// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1ClusterMemberInfo } from './V1ClusterMemberInfo';
import {
  V1ClusterMemberInfoFromJSON,
  V1ClusterMemberInfoFromJSONTyped,
  V1ClusterMemberInfoToJSON,
  V1ClusterMemberInfoToJSONTyped,
} from './V1ClusterMemberInfo';

/**
 *
 * @export
 * @interface V1ClusterStatus
 */
export interface V1ClusterStatus {
  /**
   *
   * @type {{ [key: string]: V1ClusterMemberInfo; }}
   * @memberof V1ClusterStatus
   */
  members?: { [key: string]: V1ClusterMemberInfo };
  /**
   *
   * @type {number}
   * @memberof V1ClusterStatus
   */
  membersRunningLatestVersion?: number;
  /**
   *
   * @type {number}
   * @memberof V1ClusterStatus
   */
  membersWithBoltAvailable?: number;
  /**
   *
   * @type {number}
   * @memberof V1ClusterStatus
   */
  runningMembers?: number;
  /**
   *
   * @type {number}
   * @memberof V1ClusterStatus
   */
  votingMembers?: number;
}

/**
 * Check if a given object implements the V1ClusterStatus interface.
 */
export function instanceOfV1ClusterStatus(
  value: object,
): value is V1ClusterStatus {
  return true;
}

export function V1ClusterStatusFromJSON(json: any): V1ClusterStatus {
  return V1ClusterStatusFromJSONTyped(json, false);
}

export function V1ClusterStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ClusterStatus {
  if (json == null) {
    return json;
  }
  return {
    members:
      json['Members'] == null
        ? undefined
        : mapValues(json['Members'], V1ClusterMemberInfoFromJSON),
    membersRunningLatestVersion:
      json['MembersRunningLatestVersion'] == null
        ? undefined
        : json['MembersRunningLatestVersion'],
    membersWithBoltAvailable:
      json['MembersWithBoltAvailable'] == null
        ? undefined
        : json['MembersWithBoltAvailable'],
    runningMembers:
      json['RunningMembers'] == null ? undefined : json['RunningMembers'],
    votingMembers:
      json['VotingMembers'] == null ? undefined : json['VotingMembers'],
  };
}

export function V1ClusterStatusToJSON(json: any): V1ClusterStatus {
  return V1ClusterStatusToJSONTyped(json, false);
}

export function V1ClusterStatusToJSONTyped(
  value?: V1ClusterStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    Members:
      value['members'] == null
        ? undefined
        : mapValues(value['members'], V1ClusterMemberInfoToJSON),
    MembersRunningLatestVersion: value['membersRunningLatestVersion'],
    MembersWithBoltAvailable: value['membersWithBoltAvailable'],
    RunningMembers: value['runningMembers'],
    VotingMembers: value['votingMembers'],
  };
}
